import { createStore } from 'vuex'

export default createStore({
  state: {
    imgUrl:'https://upup-1308592621.cos.ap-chongqing.myqcloud.com/zah1%',
    documentHeight:500,
    openId:null,
    userInfo:{},
    projectInfo:{}
  },
  getters: {
  },
  mutations: {
    setDocumentHeight(state,data){
      state.documentHeight=data
    },
    setOpenid(state,data){
      state.openId=data
    },
    setUserInfo(state,data){
      state.userInfo=data
    },
    setProjectInfo(state,data){
      state.projectInfo=data
    },
  },
  actions: {
  },
  modules: {
  }
})
